import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "product-past-orders"
};
const _hoisted_2 = { class: "data-item__label" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "product-past-orders__order-date" };
const _hoisted_5 = { class: "product-past-orders__order-quantity" };
const _hoisted_6 = { class: "product-past-orders__order-actions" };
import { computed, ref, watch } from 'vue';
import moment from "moment";
import orderRepository from "../services/OrderRepository";
import { useRouter } from "vue-router";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import { isGranted } from "@astina/paloma-common-ui/src/services/AccessManager";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductPastOrders',
    props: {
        product: {},
        variant: {}
    },
    setup(__props) {
        const router = useRouter();
        const props = __props;
        const pageRequest = {
            number: 0,
            size: 100, // TODO implement pageing/load more
            sort: undefined,
            order: undefined,
        };
        const infos = ref([]);
        const expanded = ref(false);
        init();
        watch(() => props.variant?.sku ?? props.product.itemNumber, () => init());
        function init() {
            infos.value = [];
            if (!isGranted('PORTAL_ORDERS_VIEW')) {
                return;
            }
            const sku = props.variant?.sku ? props.variant.sku : props.product.itemNumber;
            orderRepository.productDeliveryInfo(sku, pageRequest)
                .then(data => {
                if (data.content.length > 0) {
                    infos.value = data.content;
                }
            });
        }
        function openOrder(info) {
            if (!info)
                return;
            router.push({ name: 'orders_order', params: { orderNumber: info.orderNumber } });
        }
        function getFormattedDate(info) {
            return info.date ? moment(info.date).format('DD.MM.YYYY') : '';
        }
        const sortedInfos = computed(() => {
            if (!infos.value)
                return [];
            return [...infos.value].sort((a, b) => {
                const dateA = a.date;
                const dateB = b.date;
                //missing dates
                if (!dateA && !dateB)
                    return 0;
                if (!dateA)
                    return 1;
                if (!dateB)
                    return -1;
                return moment(dateB).diff(moment(dateA));
            });
        });
        const visibleInfos = computed(() => {
            return expanded.value
                ? sortedInfos.value
                : sortedInfos.value.slice(0, 5);
        });
        function toggleExpanded() {
            expanded.value = !expanded.value;
        }
        return (_ctx, _cache) => {
            return (infos.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('deliveries.past')), 1),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createVNode(_TransitionGroup, {
                        name: "expand",
                        tag: "div",
                        class: "product-past-orders__container"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleInfos.value, (info) => {
                                return (_openBlock(), _createElementBlock("a", {
                                    onClick: _withModifiers(($event) => (openOrder(info)), ["prevent"]),
                                    href: "",
                                    key: info.id,
                                    class: "product-past-orders__order"
                                }, [
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(getFormattedDate(info)), 1),
                                    _cache[0] || (_cache[0] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(info.quantity) + " " + _toDisplayString(info.unit), 1),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_6, [
                                        _createVNode(Icon, { name: "eye" })
                                    ])
                                ], 8, _hoisted_3));
                            }), 128)),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            (sortedInfos.value.length > 5)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: "show-more-toggle",
                                    href: "",
                                    onClick: _withModifiers(toggleExpanded, ["prevent"]),
                                    class: "product-past-orders__show-more"
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(expanded.value ? _ctx.$t('watchlist.show-less') : _ctx.$t('watchlist.show-more')), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
